import React, { useEffect, useRef } from 'react';
import { useAskFreya } from '../../pages/askFreya/AskFreyaContext';
import { MessageItem } from './MessageItem';

const ChatInterface: React.FC = () => {
  const { messages } = useAskFreya();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className='flex-1 overflow-y-auto px-8 py-6 scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-transparent'>
      <div className='max-w-4xl mx-auto'>
        {messages.map((msg) => (
          <MessageItem key={msg.id} message={msg} />
        ))}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ChatInterface;
